import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { Toaster } from "@/components/ui/sonner";
import Intro from "@/components/Intro";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import AuthModal from "@/components/AuthModal";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Story from "@/pages/Story";
import Contact from "@/pages/Contact";
import Events from "@/pages/Events";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Settings from "@/pages/Settings";

function App() {
  const [entered, setEntered] = useState(
    () => sessionStorage.getItem("majnun_entered") === "true"
  );

  const handleEnter = () => {
    sessionStorage.setItem("majnun_entered", "true");
    setEntered(true);
  };

  return (
    <div className="App grain min-h-screen">
      <SmoothScroll />
      {!entered ? (
        <Intro onEnter={handleEnter} />
      ) : (
        <BrowserRouter>
          <AuthProvider>
            <WishlistProvider>
              <CartProvider>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/product/:slug" element={<ProductDetail />} />
                    <Route path="/story" element={<Story />} />
                    <Route path="/events" element={<Events />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/settings" element={<Settings />} />
                  </Routes>
                </Layout>
                <AuthModal />
                <Toaster position="bottom-right" theme="dark" />
              </CartProvider>
            </WishlistProvider>
          </AuthProvider>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
